





















import { Component, Prop, Vue , Watch } from "vue-property-decorator";
import { Document } from '@/model/document2/document';
import { InsertionData } from '@/model/document2/insertionData/insertionData';

import InputController from "./inputController/inputController.vue"
import TableRow from "./tableRow/tableRow.vue"
import TableRowStyle from "./tableRowStyle/tableRowStyle.vue"
import TableCell from "./tableCell/tableCell.vue"

import Import from "./resources/import.vue"
import EditDesign from "./resources/editDesign.vue"
import Export from "./resources/export.vue"

import { UserAgentHelper } from '@/helper/userAgentHelper';
@Component({
  components: {
      InputController,
      TableRow,
      TableRowStyle,
      TableCell,
      Import,
      EditDesign,
      Export
  },
})
export default class RightController extends Vue 
{
    @Prop() private document!: Document;

    onDoCommand(command: string, paramater: any)
    {
        this.$emit("doCommand", command, paramater);
    }

    private get isElectron()
    {
        return UserAgentHelper.isElectron();
    }

    private get columnSelected()
    {
        return this.document.selectedInsertionWholeColumn >= 0;
    }

    // 次へ
    private goNext()
    {
        this.onDoCommand("goNext", null);
    }

    // デザイン編集
    private editDesign()
    {
        this.onDoCommand("editDesign", null);
    }

    // ファイル読み込み
    private importFile()
    {
        this.onDoCommand("importFile", null);
    }

    // ファイル書き出し
    private exportFile()
    {
        this.onDoCommand("exportFile", null);
    }

    //configcolor
    private get userConfigColors(){
        return this.$store.getters.userConfigColors;
    }

    private get buttonColorStyle(){
        return {
            "background-color" : this.userConfigColors.buttonColorCode
        }
    }
    
    
}
